import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "./baseurl";
import { useToast } from "./components/userToast";
import pagesApi from "./admincomponents/PagesApi";

export default function Contact() {
  const toast = useToast();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [content, setContent] = useState(null);

  useEffect(() => {
    pagesApi.get("contact").then(setContent).catch(() => setContent({}));
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      const { data } = await axios.post(`${BASE_URL}/contact`, formData);
      toast({ variant: "success", title: "Message sent", description: data.message || "We'll get back to you soon." });
      setFormData({ firstName: "", lastName: "", email: "", message: "" });
    } catch (err) {
      const msg = err?.response?.data?.message || "Failed to send message.";
      toast({ variant: "error", title: "Submission failed", description: msg });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="w-full bg-white mt-24 md:mt-32">
      <section className="max-w-[900px] mx-auto px-6 py-16">
        <form onSubmit={handleSubmit} className="flex flex-col gap-8">
          <div className="grid md:grid-cols-2 gap-8">
            <div>
              <label className="block text-teal-600 text-sm font-semibold tracking-wide mb-2">
              {content?.firstNameLabel || "FIRST NAME *"}
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-3 text-gray-800 focus:outline-none focus:border-teal-500"
              />
            </div>

            <div>
              <label className="block text-teal-600 text-sm font-semibold tracking-wide mb-2">
              {content?.lastNameLabel || "LAST NAME *"}
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-3 text-gray-800 focus:outline-none focus:border-teal-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-teal-600 text-sm font-semibold tracking-wide mb-2">
              {content?.emailLabel || "EMAIL *"}
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-3 text-gray-800 focus:outline-none focus:border-teal-500"
            />
          </div>

          <div>
            <label className="block text-teal-600 text-sm font-semibold tracking-wide mb-2">
              {content?.messageLabel || "MESSAGE *"}
            </label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              rows={6}
              className="w-full bg-gray-50 border border-gray-300 rounded-md px-4 py-3 text-gray-800 focus:outline-none focus:border-teal-500 resize-y"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="self-start bg-teal-500 hover:bg-teal-600 text-white font-semibold text-sm tracking-wide rounded-full px-8 py-3 transition-colors disabled:opacity-60"
          >
            {submitting ? "SENDING..." : (content?.submitLabel || "SEND")}
          </button>
        </form>
      </section>
    </div>
  );
}